// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__60B23","requiredAsterisk":"Info_requiredAsterisk__eS0WA"};